import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import dayjs from "dayjs";
import "dayjs/locale/it";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import { createTrattamenti, fetchTrattamenti, updateTrattamenti } from "../../../features/produzione-trattamenti/produzione-trattamentiThunk";
import {
  TextField,
  MenuItem,
  Button,
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Grid,
  TextareaAutosize,
  Autocomplete,
} from "@mui/material";
import styled from "@emotion/styled";
import { fetchOperatori } from "../../../features/operatori/operatoriThunk";
import { selectOperatori } from "../../../features/operatori/operatoriSlice";
import { selectTerreni } from "../../../features/terreni/terreniSlice";
import { fetchTerreni } from "../../../features/terreni/terreniThunk";
const Textarea = styled(TextareaAutosize)`
  box-sizing: border-box;
  width: 100%;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 12px;
  border-radius: 5px;
  color: #160a2a;
  background: #fff;
  border: 2px solid #e5e5e5;
`;

// Updated EmptyTextarea Component
const EmptyTextarea = ({ placeholder, value, onChange }) => {
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const handleChange = (event) => {
    setInputValue(event.target.value);
    onChange(event);
  };

  return (
    <Textarea
      aria-label="empty textarea"
      placeholder={placeholder}
      minRows={4}
      value={inputValue}
      onChange={handleChange}
    />
  );
};

const schema = yup.object().shape({
  nomeProduzione: yup.string().required("Nome della Produzione è obbligatorio"),
  idProduzione: yup.string(),
  idLotto: yup.string().required("ID Lotto è obbligatorio"),
  tipoTrattamento: yup.string().required("Tipo di trattamento è obbligatorio"),
  data: yup
    .date()
    .required("La data è obbligatoria")
    .typeError("Data non valida"),
  prodottoUtilizzato: yup
    .string()
    .required("Prodotto utilizzato è obbligatorio"),
  quantitaProdotto: yup
    .number()
    .typeError("La quantità deve essere un numero")
    .positive("La quantità deve essere positiva")
    .required("Quantità prodotto è obbligatoria"),
  modalitaApplicazione: yup
    .string(),
  operatoreResponsabile: yup
    .mixed()
    .required("Operatore responsabile è obbligatorio"),
  intervalloSicurezza: yup
    .string()
    .required("Intervallo di sicurezza è obbligatorio"),
  terreni:yup.mixed()
});
const options = ["Amministratore", "Collaboratore", "Operatore"];

dayjs.locale("it");

const ProductionTrattamentiForm = ({ cantine, singleData, setCantine }) => {
  const intervalloSicurezzaData = useSelector((store) => store.produzioneTrattamenti.siccurezza)
  const modalitaApplicazioneData = useSelector((store) => store.produzioneTrattamenti.appicazione)
  const trattamentoApplicazioneData = useSelector((store) => store.produzioneTrattamenti.trattamento)
  const isOpenTrattamentiTerni = localStorage.getItem("production")
  const operatri = useSelector(selectOperatori);
  const operatriId = operatri?.filter(op => op.role_id === "OPERATOR")
  const terreniData = useSelector(selectTerreni)
  const dispatch = useDispatch()
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  useEffect(() => {
    dispatch(fetchTerreni())
    dispatch(fetchOperatori())
  }, [dispatch])
  useEffect(() => {
    if (isOpenTrattamentiTerni) {
      const operatriObject =
        operatriId.find((t) => t.id === singleData?.operatore_id) || null;
      //  const terrenoObject = terreniId.find(t => t.id === singleData?.terreno_id) || null;
      setValue("terreno_id", singleData?.terreno_id || null);
      setValue("nomeProduzione", singleData?.name_of_produzione || null);
      setValue("idLotto", singleData?.id_lotto || null);
      setValue("tipoTrattamento", singleData?.tipo_di_trattamento || null);
      setValue("data", singleData?.date ? dayjs(singleData?.data_trattamento) : null);
      setValue("quantitaProdotto", singleData?.pro_qty || null);
      setValue("prodottoUtilizzato", singleData?.product_used || null);
      setValue("modalitaApplicazione", singleData?.mod_di_applicazione || null);
      setValue(
        "operatoreResponsabile",
        operatriObject
      );
      setValue("intervalloSicurezza", singleData?.sicurezza || null);
      setValue("note", singleData?.notes || null);
    }

  }, [singleData, setValue])

  const onSubmit = async (data) => {
    // console.log(singleData,'asdwd');

    let payload = {
      terreno_id: data.terreno_id?.id,
      name_of_produzione: data.nomeProduzione,
      id_lotto: data.idLotto,
      tipo_di_trattamento: data.tipoTrattamento,
      date: data.data ? dayjs(data.data).format("YYYY-MM-DD") : null,
      pro_qty: data.quantitaProdotto,
      product_used: data.prodottoUtilizzato,
      mod_di_applicazione: data.modalitaApplicazione,
      operatore_id: data.operatoreResponsabile?.id,
      sicurezza: data.intervalloSicurezza,
      notes: data?.note
    }
    const res = !isOpenTrattamentiTerni ? await dispatch(createTrattamenti(payload)) : await dispatch(updateTrattamenti({ id: singleData?.id, data: payload })).unwrap();
    console.log(res)
    if (res.success || res.payload.success) {
      dispatch(fetchTrattamenti());
      setCantine(false);
      localStorage.removeItem("production");
    }
  };

  return (
    <>
      <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
        <div className="AziendaFrom__inner">
          {/* <Controller
            defaultValue={null}
            name="terreno_id"
            control={control}
            render={({ field }) => (
              <Autocomplete
                options={terreniData}
                getOptionLabel={(option) => option.nome || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="terreno"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.cantina}
                    helperText={errors.cantina?.message}
                  />
                )}
                onChange={(_, value) => field.onChange(value)}
                value={field.value || null}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              />
            )}
          /> */}

          <Controller
            defaultValue=""
            name="nomeProduzione"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Nome della  Produzione"
                fullWidth
                margin="normal"
                error={!!errors.nomeProduzione}
                helperText={errors.nomeProduzione?.message}
              />
            )}
          />
          <Controller
            defaultValue=""
            name="idProduzione"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="ID Produzione"
                fullWidth
                margin="normal"
                error={!!errors.idProduzione}
                helperText={errors.idProduzione?.message}
              />
            )}
          />
          {/* <Controller
            name="idLotto"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={options}
                onChange={(event, value) => field.onChange(value)} // To handle selected value properly
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="ID Lotto"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.idLotto}
                    helperText={errors.idLotto?.message}
                  />
                )}
              />
            )}
          /> */}
          <Controller
            defaultValue=""
            name="idLotto"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="ID Lotto"
                fullWidth
                margin="normal"
                error={!!errors.idLotto}
                helperText={errors.idLotto?.message}
              />
            )}
          />

          <Controller
            defaultValue=""
            name="tipoTrattamento"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={trattamentoApplicazioneData}
                value={field.value || null}
                onChange={(event, value) => setValue("tipoTrattamento", value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo dI Trattamento"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.tipoTrattamento}
                    helperText={errors.tipoTrattamento?.message}
                  />
                )}
              />
            )}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
            <Controller
              name="data"
              control={control}
              render={({ field }) => (
                <DatePicker
                  className="datePickerField"
                  label="Data"
                  value={field.value}
                  onChange={(newValue) => field.onChange(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={!!errors.data}
                      helperText={errors.data?.message}
                      fullWidth
                      margin="normal"
                    />
                  )}
                />
              )}
            />
          </LocalizationProvider>

          <Controller
          defaultValue=""
            name="prodottoUtilizzato"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Prodotto Utilizzato"
                fullWidth
                margin="normal"
                error={!!errors.prodottoUtilizzato}
                helperText={errors.prodottoUtilizzato?.message}
              />
            )}
          />
          <Controller
          defaultValue=""
            name="quantitaProdotto"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Q.ta prodotto"
                fullWidth
                margin="normal"
                error={!!errors.quantitaProdotto}
                helperText={errors.quantitaProdotto?.message}
              />
            )}
          />

          <Controller
            defaultValue=""
            name="modalitaApplicazione"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={modalitaApplicazioneData}
                value={field.value || null}
                onChange={(event, value) => setValue("modalitaApplicazione", value)} // To handle selected value properly
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Modalità di applicazione"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.modalitaApplicazione}
                    helperText={errors.modalitaApplicazione?.message}
                  />
                )}
              />
            )}
          />

          <Controller
            defaultValue=""
            name="operatoreResponsabile"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={operatriId}
                getOptionLabel={(option) => option.name || ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={field.value || null}
                onChange={(event, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Operatore Responsabile"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.terreno_id}
                    helperText={errors.terreno_id?.message}
                  />
                )}
              />
            )}
          />

          <Controller
            defaultValue=""
            name="intervalloSicurezza"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={intervalloSicurezzaData}
                value={field.value || null}
                onChange={(event, value) => setValue("intervalloSicurezza", value)} // To handle selected value properly
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Intervallo di sicurezza"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.intervalloSicurezza}
                    helperText={errors.intervalloSicurezza?.message}
                  />
                )}
              />
            )}
          />

          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <EmptyTextarea placeholder="Note" {...field} />
            )}
          />

          <div className="btnPart1">
            <Button type="submit" variant="contained">
              Salva dati
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};

export default ProductionTrattamentiForm;
